<template>
  <div class="PlabAndRecordCom">
    <div class="tabList">
      <el-tabs v-model="activeName"
        @tab-click="handleClick">
        <el-tab-pane :label="v.name"
          :name="v.key"
          v-for="v in menuList"
          :key="v.key"></el-tab-pane>
      </el-tabs>
    </div>
    <div class="tabDetails">
      <TodayPlan v-if="activeName ==='TODAYSPLAN'" />
      <RecordTable v-else
        :activeName="activeName" />
    </div>
  </div>
</template>

<script>
import api from "@/api";
import TodayPlan from "@/components/gongzuotai/TodayPlan";
import RecordTable from "./RecordTable";
export default {
  components: {
    TodayPlan,
    RecordTable,
  },
  data() {
    return {
      activeName: "",
      menuList: [],
    };
  },
  methods: {
    handleClick() {
      // console.log(this.activeName);
    },
    async getTabList() {
      let res = await api.controlGetPlanList({
        assetId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        key: "UserPlans",
      });
      if (res && res.data.code == 200) {
        this.menuList = res.data.data;
        this.activeName = this.menuList[0].key;
      }
    },
  },
  created() {
    this.getTabList();
  },
};
</script>

<style lang="scss" scoped>
.PlabAndRecordCom {
  width: 100%;
  height: 100%;
  .tabList {
    width: 98%;
    margin: 0 auto;
    @include setFlexStart;
  }
  .tabDetails {
    width: 100%;
    height: 88%;
  }
}
</style>